import {
  AppBar,
  AvatarGroup,
  Box,
  Button,
  Card,
  Divider,
  Fab,
  FormHelperText,
  Grid,
  Toolbar,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useEffect, useState } from "react";
import { Wrapper } from "./styles";
import EastRoundedIcon from "@mui/icons-material/EastRounded";
import Modal from "../../components/Modal";
import InputForm from "../../components/controls/InputForm";
import ControlForm from "../../components/ControlForm";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { TagInput } from "../WorkflowManagement/components/TagInput/TagInput";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATH } from "../../common/constants/app.constant";
import CompanyService from "../../services/api/company.service";
import { toggleMessage } from "../../components/Toast/Toast";
import Avatar from "../../components/Avatar";
import { authTokens } from "../../services/services";
import {
  DepartMentPermissionModel,
  FeatureModel
} from "../../models/common/models.enum";
import { useApi } from "../../hooks/useApi.hook";
import LoadingOverlayWrapper from "react-loading-overlay-ts";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import SearchNoResult from "../Member/components/SearchNoResult";
import SearchInput from "../Member/components/SearchInput";
import { Helmet } from "react-helmet";
import { IBasePaging } from "../../models/common/models.type";
import { IFeaturePermission } from "../../models/user/models.roles";
import RoleService from "../../services/api/role.service";
import { AddRounded, GroupAddRounded } from "@mui/icons-material";
import { theme } from "../../theme/theme";
import { ICompany, ICreateCompanyReq } from "../../models/company";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import variableStyles from "../../theme/variable-styles";

const Company = () => {
  const today = dayjs();

  const [openCreate, setOpenCreate] = useState<boolean>(false);
  const [userId, setUserId] = useState<string | undefined>();
  const [permissions, setPermissions] = useState<string[]>([]);
  const [data, setData] = useState<ICompany[]>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const [paging, setPaging] = useState<IBasePaging | null>();
  const [searchState, setSearchState] = useState<"SUCCESS" | "NONE" | null>(
    null
  );
  const navigate = useNavigate();
  const getPage = useApi<ICompany[]>({ isFetch: true });
  const createCompany = useApi<ICompany[]>({});
  const getFeaturePersmission = useApi<IFeaturePermission[]>({ isFetch: true });
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  function fetchData(keySearch?: string, pageIndex?: number) {
    getPage.request(
      CompanyService.getPage({
        CurrentPage: pageIndex ?? 1,
        PageSize: 10,
        KeySearch: keySearch
      })
    );
    setSearchState(null);
    if (!keySearch) {
      setInputValue("");
    }
  }

  useEffect(() => {
    if (userId)
      getFeaturePersmission.request(
        RoleService.getFeaturePemissionByUserId(userId)
      );
  }, [userId]);

  useEffect(() => {
    async function getUserInfo() {
      const user = await authTokens.getUser();
      user && setUserId(user.userId);
    }
    getUserInfo();
    fetchData();
  }, []);

  useEffect(() => {
    if (getFeaturePersmission.data) {
      setPermissions(
        getFeaturePersmission.data.find(
          f => f.feature === FeatureModel.Department
        )?.permissions ?? []
      );
    }
  }, [getFeaturePersmission.data]);

  useEffect(() => {
    if (getPage.data) {
      setData(getPage?.data ?? []);
      setPaging(getPage?.pagging);
      if (getPage.data.length && inputValue.length) {
        setSearchState("SUCCESS");
      } else if (!getPage.data.length && inputValue.length) {
        setSearchState("NONE");
      }
    }
  }, [getPage.data]);

  useEffect(() => {
    if (createCompany.success) {
      toggleMessage({
        type: "success",
        message: "Tạo phòng thành công"
      });
      handleClose();
      fetchData();
    }
    if (createCompany.error) {
      toggleMessage({
        type: "error",
        message: getPage?.error ?? "Đã xảy ra lỗi"
      });
    }
  }, [createCompany.success, createCompany.error]);

  useEffect(() => {
    if (getPage.error) {
      toggleMessage({
        type: "error",
        message: getPage?.error ?? "Đã xảy ra lỗi"
      });
    }
  }, [getPage.error]);

  const validationSchema = Yup.object().shape({
    companyName: Yup.string().required(`${"Vui lòng nhập tên nhóm"}`),

    connectionString: Yup.string().required(
      `${"Vui lòng nhập connectionString"}`
    ),
    userName: Yup.string().required(`${"Vui lòng nhập tên UserName"}`),
    phoneNumber: Yup.string().required(`${"Vui lòng nhập số điện thoại"}`),
    taxIdentificationNumber: Yup.string().required(
      `${"Vui lòng nhập mã số thuế"}`
    ),
    address: Yup.string().required(`${"Vui lòng nhập địa chỉ"}`),
    email: Yup.string()
      .email()
      .matches(
        /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/,
        "Định dạng mail không hợp lệ"
      )
      .required(`${"Vui lòng nhập địa chỉ mail"}`),
    numberOfUsersCreated: Yup.string().required(`${"Vui lòng nhập địa chỉ"}`)
  }) as any;

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<ICreateCompanyReq>({
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = (request: ICreateCompanyReq) => {
    const req: ICreateCompanyReq = {
      companyName: request.companyName,
      connectionString: request.connectionString,
      address: request.address,
      email: request.email,
      phoneNumber: request.phoneNumber,
      taxIdentificationNumber: request.taxIdentificationNumber,
      userName: request.userName,
      avatar: request.avatar,
      numberOfUsersCreated: request.numberOfUsersCreated,
      expirationDate: request.expirationDate,
      iframeGoogleAds: request.iframeGoogleAds,
      iframeGoogleReport: request.iframeGoogleReport,
      memberIds: []
    };
    createCompany.request(CompanyService.create(req));
  };

  function handleClose() {
    setOpenCreate(false);
    reset();
  }

  function handleSearch() {
    if (inputValue.length > 0) {
      fetchData(inputValue, 1);
    } else {
      fetchData();
      setSearchState(null);
    }
  }

  return (
    <LoadingOverlayWrapper
      active={getPage.loading}
      text={"Đang tải dữ liệu, vui lòng chờ.."}
    >
      <Wrapper>
        <Helmet>
          <title> Quản lý tài khoản | Công ty</title>
        </Helmet>

        <AppBar position="static" color="default">
          <Toolbar>
            <Box flexGrow={1}>
              <SearchInput
                input={inputValue}
                placeholder="Tìm kiếm nhóm.."
                isSuccess={searchState === "SUCCESS"}
                search={handleSearch}
                clear={() => fetchData()}
                value={inputValue}
                countResult={data?.length ?? 0}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setInputValue(event.target.value);
                }}
              />
            </Box>
            {permissions.includes(DepartMentPermissionModel.Create) && (
              <Button
                variant="contained"
                size="small"
                sx={{
                  borderRadius: "4px",
                  backgroundColor: variableStyles.MainColor
                }}
                onClick={_ => setOpenCreate(true)}
              >
                {matches ? (
                  <GroupAddRounded />
                ) : (
                  <Typography> Tạo công ty</Typography>
                )}
              </Button>
            )}
            <Modal
              title="Tạo công ty"
              textSubmit="Tạo công ty"
              textClose="Huỷ bỏ"
              open={openCreate}
              onSubmit={handleSubmit(onSubmit)}
              onClose={handleClose}
              loadingState={createCompany.loading}
            >
              <form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px"
                }}
              >
                <ControlForm
                  title="Tên công ty"
                  isRequired
                  classname="brand-form"
                >
                  <InputForm
                    placeholder="Tên công ty"
                    required
                    name="companyName"
                    errors={errors}
                    control={control}
                    size="small"
                    disabled={createCompany.loading}
                  />
                </ControlForm>
                <ControlForm title="UserName" classname="brand-form" isRequired>
                  <InputForm
                    placeholder={"UserName"}
                    required
                    name={"userName"}
                    errors={errors}
                    control={control}
                    size="small"
                    // defaultValue={item?.name}
                  />
                </ControlForm>
                <ControlForm title="Email" classname="brand-form" isRequired>
                  <InputForm
                    placeholder={"Email"}
                    required
                    name={"email"}
                    errors={errors}
                    control={control}
                    size="small"
                    // defaultValue={item?.name}
                  />
                </ControlForm>
                <ControlForm
                  title="Số điện thoại"
                  classname="brand-form"
                  isRequired
                >
                  <InputForm
                    placeholder={"Số điện thoại"}
                    required
                    name={"phoneNumber"}
                    errors={errors}
                    control={control}
                    size="small"
                    // defaultValue={item?.name}
                  />
                </ControlForm>
                <ControlForm
                  title="Mã số thuế"
                  classname="brand-form"
                  isRequired
                >
                  <InputForm
                    placeholder={"Mã số thuế"}
                    required
                    name={"taxIdentificationNumber"}
                    errors={errors}
                    control={control}
                    size="small"
                    // defaultValue={item?.name}
                  />
                </ControlForm>
                <ControlForm title="Địa chỉ" classname="brand-form" isRequired>
                  <InputForm
                    placeholder={"Địa chỉ"}
                    required
                    name={"address"}
                    errors={errors}
                    control={control}
                    size="small"
                    // defaultValue={item?.name}
                  />
                </ControlForm>
                <ControlForm
                  title="Số lượng user được phép tạo"
                  classname="brand-form"
                  isRequired
                >
                  <InputForm
                    placeholder={"Số lượng user được phép tạo"}
                    required
                    name={"numberOfUsersCreated"}
                    errors={errors}
                    control={control}
                    size="small"
                    type="number"
                    // defaultValue={item?.name}
                  />
                </ControlForm>
                <ControlForm title="Ngày hết hạn" classname="brand-form">
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="vi"
                  >
                    <Controller
                      name="expirationDate"
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error, invalid }
                      }) => (
                        <>
                          <MobileDatePicker
                            disablePast
                            minDate={today}
                            value={value}
                            dayOfWeekFormatter={date => date.format("dd")}
                            onChange={newDate =>
                              onChange(
                                newDate
                                  ? dayjs(newDate)
                                      .hour(value ? value.hour() : 0)
                                      .minute(value ? value.minute() : 0)
                                  : null
                              )
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                placeholder: "Nhấn để chọn ngày",
                                InputProps: {
                                  readOnly: true,
                                  sx: {
                                    cursor: "pointer",
                                    "& .MuiSvgIcon-root": {
                                      width: 24,
                                      height: 24
                                    }
                                  }
                                },
                                sx: {
                                  "& input": {
                                    padding: "10px 12px!important"
                                  }
                                }
                              },
                              toolbar: {
                                className: "dialog-toolbar",
                                sx: {
                                  span: {
                                    fontSize: 12
                                  },
                                  h4: {
                                    fontSize: 20
                                  }
                                }
                              },
                              calendarHeader: {
                                sx: {
                                  "& .MuiPickersCalendarHeader-labelContainer":
                                    {
                                      fontSize: 16
                                    },
                                  "& .MuiSvgIcon-root": {
                                    width: 24,
                                    height: 24
                                  },
                                  button: { fontSize: 18 }
                                }
                              },
                              mobilePaper: {
                                sx: {
                                  "& .MuiDayCalendar-weekDayLabel": {
                                    fontSize: 12
                                  },
                                  "& .MuiPickersDay-root": {
                                    fontSize: 12
                                  },
                                  "& .MuiPickersMonth-monthButton": {
                                    fontSize: 14
                                  },
                                  "& .MuiPickersYear-yearButton": {
                                    fontSize: 14
                                  },
                                  "& .MuiButtonBase-root": {
                                    fontSize: 14
                                  }
                                }
                              }
                            }}
                          />

                          {error && (
                            <FormHelperText sx={{ color: "#ED3E47" }}>
                              {error.message}
                            </FormHelperText>
                          )}
                        </>
                      )}
                    />
                  </LocalizationProvider>
                </ControlForm>
                <ControlForm title="Key" isRequired classname="brand-form">
                  <InputForm
                    placeholder={"Key"}
                    required
                    name={"connectionString"}
                    errors={errors}
                    control={control}
                    size="small"
                    // defaultValue={item?.userName}
                  />
                </ControlForm>
              </form>
            </Modal>
          </Toolbar>
        </AppBar>

        {searchState === "NONE" && (
          <SearchNoResult
            keySearch={inputValue}
            title={"phòng ban"}
            clearSearch={() => fetchData()}
          />
        )}

        <Box
          sx={{
            margin: "12px 14px"
          }}
        >
          <Grid container spacing={2} columns={16}>
            {!data.length ? (
              <Typography
                variant="body2"
                sx={{
                  textAlign: "center",
                  alignContent: "center",
                  height: "75vh",
                  width: "100vw"
                }}
              >
                Danh sách trống
              </Typography>
            ) : (
              data.map((item, idx) => (
                <Grid key={item.id} item xs={matches ? 16 : 8}>
                  <Card
                    sx={{ padding: "16px" }}
                    onClick={() =>
                      navigate(`${ROUTE_PATH.ACCOUNT_COMPANY}/${item.id}`)
                    }
                  >
                    <Box display="flex">
                      <Box
                        sx={{
                          backgroundColor: "#e8efee",
                          borderRadius: "8px",
                          width: "44px",
                          height: "44px",
                          textAlign: "center",
                          alignContent: "center",
                          fontSize: "16px",
                          fontWeight: "600"
                        }}
                      >
                        {idx + 1 < 10 ? "0" : ""}
                        {idx + 1}
                      </Box>
                      <Box sx={{ marginLeft: "12px", flexGrow: 1 }}>
                        <Typography variant="subtitle1" className="card-name">
                          {item.companyName}
                        </Typography>
                        <Box display="flex">
                          <Typography
                            variant="subtitle2"
                            className="card-username"
                          >
                            {item.connectionString}
                          </Typography>
                        </Box>
                      </Box>
                      <EastRoundedIcon />
                    </Box>

                    <Box display="flex" marginTop="10px">
                      {/* <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ margin: "0 12px" }}
                      /> */}
                      <Box flexGrow={1} display="flex" flexDirection="column">
                        <Typography
                          className="card-username"
                          variant="caption"
                          flexGrow={1}
                        >
                          QUẢN TRỊ VIÊN
                        </Typography>
                        {!!item.infoCEO ? (
                          <Box
                            display="flex"
                            alignItems="center"
                            marginTop="2px"
                          >
                            <Avatar
                              src={item.infoCEO?.avatar}
                              width={24}
                              height={24}
                            />
                            <Typography
                              variant="caption"
                              marginLeft="8px"
                              className="card-leader"
                            >
                              {item.infoCEO?.fullName}
                            </Typography>
                          </Box>
                        ) : (
                          <Typography variant="caption" marginTop="4px">
                            Chưa có quản trị viên
                          </Typography>
                        )}
                      </Box>

                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ margin: "0 12px" }}
                      />

                      <Box
                        flexGrow={1}
                        flexDirection="column"
                        display="flex"
                        alignItems="end"
                      >
                        <Typography
                          className="card-username"
                          variant="caption"
                          flexGrow={1}
                        >
                          {item.infoMembers?.length} Thành viên
                        </Typography>
                        {item.infoMembers?.length === 0 ? (
                          <Typography variant="caption" marginTop="4px">
                            Chưa có thành viên
                          </Typography>
                        ) : (
                          <Box display="flex" justifyContent="space-between">
                            <AvatarGroup
                              total={item.infoMembers?.length}
                              max={4}
                              sx={{
                                "& .MuiAvatar-root": {
                                  width: 24,
                                  height: 24,
                                  fontSize: 15
                                }
                              }}
                            >
                              {item.infoMembers?.map(info => (
                                <Avatar
                                  key={info.id}
                                  src={info?.avatar}
                                  width={24}
                                  height={24}
                                />
                              ))}
                            </AvatarGroup>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
          {paging && paging.currentPage !== paging.totalPages && (
            <Button
              size="small"
              onClick={() => fetchData(undefined, paging.currentPage + 1)}
            >
              Xem thêm
              <ExpandMoreRoundedIcon />
            </Button>
          )}
        </Box>
      </Wrapper>
    </LoadingOverlayWrapper>
  );
};

export default Company;

//30->21.5
//24->15.5
//33->24.5
//13->4.5
//30->21.5
//29->20.5
//30->21.5
//39->30.5
//23->14.5
//33->24.5
